





































import axios from 'axios';
import CoAlert from '../co-alert/CoAlert.vue';
import {
    AudioProvider,
    getAudioOEmbedUrl,
    getAudioProvider,
    getDirectAudioEmbedUrl,
    getTrustedAudioEmbedUrl,
} from '../../../utils/video.ts';

// Provider requests must not inherit application authentication headers.
const oEmbedClient = axios.create();
const DEFAULT_EMBED_HEIGHT = 180;
const MIN_EMBED_HEIGHT = 105;
const MAX_EMBED_HEIGHT = 450;
const PODIGEE_MIN_EMBED_HEIGHT = 180;

export default {
    name: 'CoAudioEmbed',
    components: {
        CoAlert,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            embedUrl: null,
            embedTitle: '',
            embedHeight: DEFAULT_EMBED_HEIGHT,
            hasError: false,
            requestSequence: 0,
        };
    },
    watch: {
        url: {
            handler() {
                this.loadEmbed();
            },
            immediate: true,
        },
    },
    methods: {
        async loadEmbed() {
            this.requestSequence += 1;
            const { requestSequence } = this;
            const provider = getAudioProvider(this.url) as AudioProvider | null;
            const directEmbedUrl = getDirectAudioEmbedUrl(this.url);
            const oEmbedUrl = getAudioOEmbedUrl(this.url);

            this.embedUrl = null;
            this.embedTitle = '';
            this.embedHeight = DEFAULT_EMBED_HEIGHT;
            this.hasError = false;

            if (!provider) {
                this.hasError = true;
                return;
            }

            if (directEmbedUrl) {
                this.embedUrl = directEmbedUrl;
                this.embedTitle = this.$t(`labels.${provider}AudioPlayer`);
                this.embedHeight = new URL(directEmbedUrl).searchParams.has('i') ? 175 : 450;
                return;
            }

            if (!oEmbedUrl) {
                this.hasError = true;
                return;
            }

            try {
                const response = await oEmbedClient.get(oEmbedUrl);
                if (requestSequence !== this.requestSequence) {
                    return;
                }

                const embedUrl = getTrustedAudioEmbedUrl(response.data?.html, provider);
                const responseHeight = Number(response.data?.height);
                this.embedUrl = embedUrl;
                this.embedTitle = response.data?.title || this.$t(`labels.${provider}AudioPlayer`);
                // Podigee's compact oEmbed height can crop the redirected player at responsive widths.
                const providerMinimumHeight = provider === 'podigee' ? PODIGEE_MIN_EMBED_HEIGHT : MIN_EMBED_HEIGHT;
                this.embedHeight = Number.isFinite(responseHeight)
                    ? Math.min(Math.max(responseHeight, providerMinimumHeight), MAX_EMBED_HEIGHT)
                    : DEFAULT_EMBED_HEIGHT;
                this.hasError = !embedUrl;
            } catch (error) {
                if (requestSequence !== this.requestSequence) {
                    return;
                }

                this.embedUrl = null;
                this.hasError = true;
            }
        },
    },
};
